export default function getRemainingRequest(loaderContext) {
    return loaderContext.remainingRequests;
}
